module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b43cc43126fe68b9f0be90b67f65c3ec.png";